export default {
  setUserCampaings(state, payload) {
    // console.log(`setUserCamp mutation ${payload}`)
    state.campaigns = payload

    // console.log(state.campaigns)
  },
}
